import React from "react";

const Washing_28 = React.forwardRef(
  ({ width = "41", height = "32", viewBox = "0 0 41 32", fill = "none", className }, ref) => {
    return (
      <svg
        ref={ref}
        {...{ width, height, viewBox, fill, className }}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M31.592 23.8527C29.0739 27.5626 24.8216 30 20 30C15.2258 30 11.0098 27.6103 8.48279 23.9618L20.1517 17.2834L31.592 23.8527ZM32.5965 22.117L22.1686 16.1291L32.7004 10.1015C33.5344 11.8941 34 13.8927 34 16C34 18.1934 33.4956 20.2689 32.5965 22.117ZM33.3308 24.8512L39.2592 28.2554L40.2883 26.5339L34.3348 23.1152C35.4006 20.9721 36 18.556 36 16C36 13.531 35.4408 11.1927 34.4421 9.10469L40.3054 5.74901L39.2795 4.02586L33.4649 7.35369C30.6184 2.92995 25.6514 0 20 0C14.4114 0 9.49202 2.86524 6.63071 7.20687L1.04602 4L0.016932 5.72152L5.63433 8.94717C4.58779 11.0748 4 13.4688 4 16C4 18.6021 4.62115 21.0591 5.72327 23.2308L0 26.5064L1.02583 28.2295L6.74118 24.9585C9.6176 29.2074 14.4827 32 20 32C25.5636 32 30.464 29.1603 33.3308 24.8512ZM7.46197 22.2357L18.1367 16.1263L7.37321 9.94568C6.49307 11.778 6 13.8314 6 16C6 18.2405 6.52629 20.358 7.46197 22.2357ZM8.36903 8.20505L20.1536 14.972L31.7262 8.34878C29.2267 4.52592 24.9084 2 20 2C15.1534 2 10.8821 4.46273 8.36903 8.20505Z"
          fill="black"
        />
      </svg>
    );
  },
);

export default Washing_28;
